import { PROJECT_TAB_KEYS } from "constants/projectTabs"
import { ROUTES } from "constants/routes"

/** The Provenance tab's sections, as `?section=` names them. */
export const PROVENANCE_SECTIONS = [
  "timeline",
  "stamp",
  "compare",
  "trackers",
  "lineage",
  "ancestry",
] as const

export type ProvenanceSection = (typeof PROVENANCE_SECTIONS)[number]

export const isProvenanceSection = (
  value: string | null
): value is ProvenanceSection =>
  value !== null && (PROVENANCE_SECTIONS as readonly string[]).includes(value)

/** The project page on the Provenance tab, open on `section`. */
export const provenanceLink = (
  projectId: string,
  section: ProvenanceSection
): string =>
  `${ROUTES.PROJECT(projectId)}?tab=${PROJECT_TAB_KEYS.PROVENANCE}&section=${section}`

/** The project page on the questionnaire, its history open at version `seq`. */
export const editorHistoryLink = (projectId: string, seq: number): string =>
  `${ROUTES.PROJECT(projectId)}?tab=${PROJECT_TAB_KEYS.QUESTIONNAIRE}&history=${seq}`
